<template>
    <page title="competitionApprovalAttachments" :textHeight="(WindowSize.y - 276) + 'px'">
        <template #pageContainer>
			<v-form ref="form" v-model="valid">
				<v-row v-if="!isViewMode"><v-col>
					<p>{{ $t(`text.createApprovalHint3`) }}</p>
					<p>{{ $t(`text.createApprovalHint4`) }}</p>
					<p>{{ $t(`text.createApprovalHint5`) }}</p>
				</v-col></v-row>
				<v-row v-if="!isViewMode"><v-col>
					<ul>
						<li v-for="(item, i) in allowedFormats"
							:key="i">
							{{item.text}}
						</li>
					</ul>
				</v-col></v-row>

				<v-row v-if="getAttachmentSorted.length !== 0"><v-col>

					<v-list>

						<v-list-item
						v-for="(at, i) in getAttachmentSorted"
						:key="`at-${i}`">

						<v-list-item-content>
							<v-list-item-title v-text="`${at.title} (${getFileGroup(at.attachmentGroup)})`"></v-list-item-title>
							<v-list-item-subtitle v-if="at.attachmentType===0" v-html="at.text"></v-list-item-subtitle>
							<v-list-item-subtitle v-if="at.attachmentType===1"><a @click="loadFile(at.file)" target="_blank">{{$t('text.download')}}</a></v-list-item-subtitle>
							<v-list-item-subtitle v-if="at.attachmentType===2"><a :href="at.text" target="_blank">{{at.text}}</a></v-list-item-subtitle>
						</v-list-item-content>

						<v-list-item-icon @click="editAttachement(at.id)" v-if="[0,2].includes(at.attachmentType)">
							<v-btn class="ma-2" text icon>
								<v-icon>edit</v-icon>
							</v-btn>
						</v-list-item-icon>
						<v-list-item-icon @click="deleteAttachement(at.id)">
							<v-btn class="ma-2" text icon>
								<v-icon>delete</v-icon>
							</v-btn>
						</v-list-item-icon>
						</v-list-item>
					</v-list>
				</v-col></v-row>
				<v-row v-else><v-col>
					<v-alert
						dense
						type="warning">
						{{$t('text.noDataFound')}}
					</v-alert>
				</v-col></v-row>
				<v-row v-if="!isViewMode"><v-col>
					<v-btn
						class="mr-4"
						@click="showMask = !showMask">
						{{ $t(`text.addAdInfo`) }}
					</v-btn>
				</v-col></v-row>
				<template v-if="showMask && !isViewMode">
					<v-row><v-col>
						<v-select outlined dense
							hide-details="auto"
							:disabled="attachment.id != null"
							v-model="attachment.attachmentType"
							:items="attachmentType"
							:label="$t('text.type')">
						</v-select>
					</v-col></v-row>
					<v-row><v-col cols="12" sm="4" lg="4">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							clearable
							v-model="attachment.title"
							:label="$t('text.fileTitle')+'*'"
							:error-messages="errors('title')"
							:rules="[rules.notEmpty, rules.maxLen200]"
							required
							@input="$v.attachment.title.$touch()"
							@blur="$v.attachment.title.$touch()">
						</v-text-field>
					</v-col><v-col cols="12" sm="4" lg="4">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							clearable
							v-model.number="attachment.sort"
							:label="$t('text.fileSort')+'*'"
							:error-messages="errors('sort')"
							:rules="[rules.notEmpty]"
							required
							@input="$v.attachment.sort.$touch()"
							@blur="$v.attachment.sort.$touch()">
						</v-text-field>
					</v-col><v-col cols="12" sm="4" lg="4">
						<v-autocomplete outlined dense
							hide-details="auto"
							:items="fileGroups"
							class="mt-0 pt-0"
							clearable
							v-model="attachment.attachmentGroup"
							:label="$t('text.fileGroup')+'*'"
							:error-messages="errors('group')"
							:rules="[rules.notEmpty]"
							required
							@input="$v.attachment.attachmentGroup.$touch()"
							@blur="$v.attachment.attachmentGroup.$touch()">
						</v-autocomplete>
					</v-col></v-row>
					<v-row><v-col>
						<v-text-field outlined dense
							hide-details="auto"
							v-if="attachment.attachmentType===2"
							class="mt-0 pt-0"
							clearable
							v-model="attachment.link"
							:label="$t('text.attachmentType.link')+'*'"
							:error-messages="errors('link')"
							:rules="[rules.notEmpty, rules.link]"
							required
							@input="$v.attachment.link.$touch()"
							@blur="$v.attachment.link.$touch()">
						</v-text-field>
						<v-textarea
							outlined
							hide-details="auto"
							v-if="attachment.attachmentType===0"
							class="mt-0 pt-0"
							clearable
							v-model="attachment.text"
							:label="$t('text.attachmentType.text')+'*'"
							:error-messages="errors('text')"
							:rules="[rules.notEmpty, rules.maxLen300]"
							required
							@input="$v.attachment.text.$touch()"
							@blur="$v.attachment.text.$touch()">
						</v-textarea>
						<v-file-input v-if="attachment.attachmentType===1" :label="$t('text.attachmentType.file')+'*'" v-model="attachment.file"
							:rules="[rules.notEmpty, rules.maxFileLen200]"
							dense outlined
							hide-details="auto"
							accept=".jpeg,.jpg,.png,.html,.pdf,.doc,.docx,.xls,.xlsx,.txt"></v-file-input>
					</v-col></v-row>
					<v-row><v-col>
						<v-btn
							class="mr-4"
							:disabled="loading"
							@click="saveAttachment">
							{{ $t(`text.save`) }}
						</v-btn>
						<v-btn
							class="mr-4"
							:disabled="loading"
							@click="abortAttachment">
							{{ $t(`text.abort`) }}
						</v-btn>
					</v-col></v-row>
				</template>
				<v-row><v-col>
				</v-col></v-row>
            </v-form>
            <spinner :loading="loading"></spinner>
        </template>
		<template #pageActions>
			<v-row>
				<v-col>
					<v-btn
						class="mr-4"
						v-if="!isAttacheModeOnly"
						@click="backToOverview">
						{{ $t(`text.backToOverview`) }}
					</v-btn>
					<v-btn
						v-if="!isViewMode && !isAttacheModeOnly"
						class="mr-4"
						@click="next">
						{{ $t(`text.createAndNext`) }}
					</v-btn>
					<v-btn
						:disabled="loading"
						class="mr-4"
						@click="back">
						{{ $t(`text.backButton`) }}
					</v-btn>
				</v-col>
			</v-row>
        </template>
    </page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import { required, requiredIf } from 'vuelidate/lib/validators';

import compApprovalActions from '../store/actions/compApproval';
import namespace from '../store/namespace';


import getAllowedFormats from '../models/allowedFormats';
import getAttachmentTypes from '../models/attachmentType';
import getFileGroups from '../models/fileGroups';
import modelState from '../mixins/modelState';

import Page from '../general/Page.vue';
import Spinner from '../general/Spinner.vue';

export default {
	name: 'CompetitionApprovalAttachments',
	mixins: [modelState],
	components: {
		Page,
		Spinner,
	},
	validations: {
		attachment: {
			attachmentType: {
				required,
			},
			title: {
				required,
			},
			sort: {
				required,
			},
			attachmentGroup: {
				required,
			},
			text: {
			// eslint-disable-next-line func-names
				required: requiredIf(function () {
					return this.attachment.attachmentType === 0;
				}),
			},
			link: {
			// eslint-disable-next-line func-names
				required: requiredIf(function () {
					return this.attachment.attachmentType === 2;
				}),
			},
			file: {
			// eslint-disable-next-line func-names
				required: requiredIf(function () {
					return this.attachment.attachmentType === 1;
				}),
			},
		},
	},

	data() {
		return {
			valid: true,
			loading: false,
			attachment: {
				attachmentType: 0,
				title: null,
				sort: null,
				attachmentGroup: 0,
				text: null,
				link: null,
				file: null,
			},
			showMask: false,
			pattern: new RegExp('^(https?:\\/\\/)?' // protocol
    + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' // domain name
    + '((\\d{1,3}\\.){3}\\d{1,3}))' // OR ip (v4) address
    + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port and path
    + '(\\?[;&a-z\\d%_.~+=-]*)?' // query string
    + '(\\#[-a-z\\d_]*)?$', 'i'), // fragment locator
			rules: {
				notEmpty: v => (v !== null && v !== undefined && String(v).trim() !== '') || this.$i18n.t('text.errorEmpty'),
				link: v => (v !== null && v !== undefined && !!this.pattern.test(v)) || this.$i18n.t('text.errorInvalidUrl'),
				maxLen200: v => (v == null || v.length <= 200) || this.$i18n.t('text.toLong'),
				maxLen300: v => (v == null || v.length <= 300) || this.$i18n.t('text.toLong'),
				maxFileLen200: v => (v == null || v.name.length <= 200) || this.$i18n.t('text.toLong'),
			},
		};
	},
	async mounted() {
		this.loading = true;
		if (this.CompApprLinks.length === undefined || this.CompApprLinks.length === 0) {
			await this.GET_COMP_APPROVAL_LINKS();
		}
		if (!this.Competition || this.Competition.id !== this.cGuid) {
			const link = this.CompApprLinks.find(x => x.rel === 'get_by_id');
			if (link) {
				await this.GET_COMP_BY_ID({ link, cGuid: this.cGuid });
			}
		}
		this.loading = false;
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.USER, ['IsApprover']),
		...mapGetters(namespace.COMPETITIONAPPROVAL, ['CompApprLinks', 'Competition']),
		cGuid() {
			return this.$route.params.cGuid || null;
		},
		allowedFormats() {
			return getAllowedFormats(this);
		},
		attachmentType() {
			return getAttachmentTypes(this);
		},
		fileGroups() {
			return getFileGroups(this, [6, 7, 8, 9]);
		},
		getFileGroup: state => fGId => state.fileGroups.find(x => x.value === (fGId || 0)).text,
		getAttachmentSorted() {
			if (this.Competition && this.Competition.attachments) {
				const at = this.Competition.attachments;
				return at.sort((a, b) => (a.sort > b.sort ? 1 : -1));
			}
			return [];
		},
		isViewMode() {
			return this.$route.name === 'showcompApprovalAttachments';
		},
		isAttacheModeOnly() {
			return this.$route.name === 'compApprovalAttachmentsOnly';
		},
	},
	methods: {
		...mapActions(namespace.COMPETITIONAPPROVAL, [
			compApprovalActions.GET_COMP_APPROVAL_LINKS,
			compApprovalActions.GET_COMP_BY_ID,
			compApprovalActions.SEND_ATTACHMENT,
			compApprovalActions.DELETE_ATTACHEMENT,
		]),
		errors(name) {
			const errors = [];
			const apiErrors = this.validateProperty(name);
			if (apiErrors.length > 0) {
				errors.push(apiErrors);
			}

			return errors;
		},
		async deleteAttachement(id) {
			this.loading = true;
			let link = null;
			link = this.CompApprLinks.find(x => x.rel === 'delete_attachment');

			if (link) {
				try {
					this.modelState = {};
					await this.DELETE_ATTACHEMENT({ link, cGuid: id });
				} catch (e) {
					console.log(e);
					if (e.response.status === 422) {
						this.modelState = e.response.data;
						if (this.modelError()) {
							throw new Error(this.modelError());
						}
					}

					throw e;
				} finally {
					this.loading = false;
				}
			}
			link = this.CompApprLinks.find(x => x.rel === 'get_by_id');
			if (link) {
				await this.GET_COMP_BY_ID({ link, cGuid: this.cGuid });
			}
		},
		editAttachement(id) {
			this.readDTO(id);
			this.showMask = true;
		},
		async saveEditAttachement() {
			this.loading = true;
			this.$v.$touch();
			this.$refs.form.validate();

			if (!this.$v.$invalid && this.valid) {
				let link = null;
				const dto = this.writeDTO();
				link = this.CompApprLinks.find(x => x.rel === 'edit_attachment');

				if (link) {
					try {
						this.modelState = {};
						await this.SEND_ATTACHMENT({ link, cGuid: this.cGuid, upload: dto });
					} catch (e) {
						console.log(e);
						if (e.response.status === 422) {
							this.modelState = e.response.data;
							if (this.modelError()) {
								throw new Error(this.modelError());
							}
						}

						throw e;
					} finally {
						this.loading = false;
					}
				}
				this.clear();
				link = this.CompApprLinks.find(x => x.rel === 'get_by_id');
				if (link) {
					await this.GET_COMP_BY_ID({ link, cGuid: this.cGuid });
				}
			} else if (!this.valid && this.$refs.form.errorBag) {
				const id = Object.entries(this.$refs.form.errorBag).find(x => x[1] == true)[0];
				if (id) document.getElementById(`input-${id}`).scrollIntoView();
			}
			this.loading = false;
		},
		async upload() {
			this.loading = true;
			this.$v.$touch();
			this.$refs.form.validate();

			if (!this.$v.$invalid && this.valid) {
				let link = null;
				const dto = this.writeDTO();
				link = this.CompApprLinks.find(x => x.rel === 'new_attachment');

				if (link) {
					try {
						this.modelState = {};
						await this.SEND_ATTACHMENT({ link, cGuid: this.cGuid, upload: dto });
					} catch (e) {
						console.log(e);
						if (e.response.status === 422) {
							this.modelState = e.response.data;
							if (this.modelError()) {
								throw new Error(this.modelError());
							}
						}

						throw e;
					} finally {
						this.loading = false;
					}
				}
				this.clear();
				link = this.CompApprLinks.find(x => x.rel === 'get_by_id');
				if (link) {
					await this.GET_COMP_BY_ID({ link, cGuid: this.cGuid });
				}
			} else if (!this.valid && this.$refs.form.errorBag) {
				const id = Object.entries(this.$refs.form.errorBag).find(x => x[1] == true)[0];
				if (id) document.getElementById(`input-${id}`).scrollIntoView();
			}
			this.loading = false;
		},
		async saveAttachment() {
			if (this.attachment.id) {
				await this.saveEditAttachement();
			} else {
				await this.upload();
			}
		},
		abortAttachment() {
			this.showMask = false;
			this.clear();
		},
		writeDTO() {
			const data = new FormData();
			if (this.attachment.id) {
				data.append('id', this.attachment.id);
			}
			data.append('file', this.attachment.file);
			data.append('title', this.attachment.title);
			data.append('sort', this.attachment.sort);
			data.append('text', this.attachment.text || this.attachment.link);
			data.append('attachmentType', this.attachment.attachmentType);
			data.append('attachmentGroup', this.attachment.attachmentGroup);
			return data;
		},
		readDTO(id) {
			const a = this.getAttachmentSorted.find(x => x.id === id);
			if (a) {
				this.attachment = JSON.parse(JSON.stringify(a));
				this.attachment.link = this.attachment.text;
			} else {
				// error
			}
		},
		clear() {
			this.attachment.file = null;
			this.attachment.title = null;
			this.attachment.sort = null;
			this.attachment.text = null;
			this.attachment.link = null;
			this.attachment.attachmentType = 0;
			this.attachment.attachmentGroup = 0;
			this.$refs.form.reset();
		},
		next() {
			if (this.$route.name === 'compApprovalAttachments') {
				this.$router.push({
					name: 'compApprovalRequest',
					params: { cGuid: this.cGuid },
				});
			} else {
				this.$router.push({
					name: 'compApprovalFinisher',
					params: { cGuid: this.cGuid },
				});
			}
		},
		backToOverview() {
			this.$router.push({ name: 'competitionapproval' });
		},
		back() {
			this.$router.go(-1);
		},
		loadFile(url) {
			//this.downloadWithAxios(`https://localhost:44344/${url}`);
			this.downloadWithAxios(`${window.location.origin}/${url}`);
		},

		forceFileDownload(response) {
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = response.config.url.substring(response.config.url.lastIndexOf('/') + 1);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
		},

		downloadWithAxios(url) {
			axios({
				method: 'get',
				url,
				responseType: 'arraybuffer',
			})
				.then((response) => {
					this.forceFileDownload(response);
				})
				.catch(() => console.log('error occured'));
		},
	},
};
</script>
